import {
    ActionButton,
    Content,
    Dialog,
    DialogTrigger,
    Divider,
    Heading,
} from '@adobe/react-spectrum';
import ShareAndroid from '@spectrum-icons/workflow/ShareAndroid';
import QRCode from 'react-qr-code';
import Copy from '@spectrum-icons/workflow/Copy';
import React from 'react';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { toast } from 'react-toastify';
import './BreadCrumbShareButton.css';

export function BreadCrumbShareButton(props) {
    const title = props?.label || 'Share';
    const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

    const copyLink = () => {
        navigator.clipboard.writeText(shareUrl);
        logEvent(getAnalytics(), `share_ ${title}`);
        toast('Link copied!');
    };

    return (
        <DialogTrigger type={'modal'}>
            <ActionButton isDisabled={props.isDisabled} aria-label={title}>
                <span className="bcBtnLabel">Share</span>
                <ShareAndroid />
            </ActionButton>
            {(close) => (
                <Dialog
                    width={'calc(100vw - 40px)'}
                    maxWidth={500}
                    UNSAFE_className="bcShareDialog"
                >
                    <Heading>
                        <span className="bcShareEyebrow">Share</span>
                        <span className="bcShareTitle">{title}</span>
                    </Heading>
                    <Divider />
                    <Content>
                        <div className="bcShareBody">
                            <section className="bcShareQrCard">
                                <span className="bcShareEyebrow bcShareEyebrow--sub">
                                    Scan to open
                                </span>
                                <div className="bcShareQrFrame">
                                    <QRCode
                                        value={shareUrl}
                                        bgColor={'#0a0a0a'}
                                        fgColor={'#ff3b3b'}
                                        size={192}
                                    />
                                </div>
                            </section>
                            <section className="bcShareLinkCard">
                                <span className="bcShareEyebrow bcShareEyebrow--sub">
                                    Copy link
                                </span>
                                <button
                                    type="button"
                                    className="bcShareLinkRow"
                                    onClick={copyLink}
                                    title="Click to copy"
                                >
                                    <span className="bcShareLinkText">{shareUrl}</span>
                                    <span className="bcShareLinkCopy" aria-hidden="true">
                                        <Copy size="S" />
                                    </span>
                                </button>
                                <span className="bcShareHint">
                                    Click the link above to copy it to your clipboard.
                                </span>
                            </section>
                        </div>
                        <div className="bcShareActions">
                            <ActionButton onPress={close} aria-label="Close">
                                <span className="bcBtnLabel">Close</span>
                            </ActionButton>
                        </div>
                    </Content>
                </Dialog>
            )}
        </DialogTrigger>
    );
}
